import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { createUseStyles } from 'react-jss';
import { ThemeContext } from 'styled-components';

import { connect } from 'react-redux';
import { resultsConfigSelector } from 'ctm-selectors';
import { Link } from '@comparethemarketau/manor-link';
import { faSlidersH } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { Typography } from '@comparethemarketau/manor-typography';
import { FiltersRefineModal } from './common/filters_refine_modal';
import { ExcessFilterDrawer } from './common/excess_filter_drawer';
import { Separator } from '../products/common/separator';

import { SortDrawer } from '../sorts/common/sort_drawer';
import { ContainerWrapper } from '../container_wrapper';

const useStyles = createUseStyles((theme) => ({
    container: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between'
    },
    leftSection: {
        display: 'flex',
        flexDirection: 'row'
    },
    separator: {
        margin: {
            right: theme.spacing[8],
            left: '0.9rem'
        }
    },
    icon: {
        marginRight: theme.spacing[4],
        fontSize: theme.fontSize.sm
    }
}));

const _PolicyFiltersXs = (props) => {
    const theme = useContext(ThemeContext);
    const classes = useStyles({ theme });

    const { isShowFiltersUpdateButton, padding } = props;

    return (
        <ContainerWrapper padding={padding} className={classNames('test-policyFilters-xs', classes.container)}>
            <div className={classes.leftSection}>
                <FiltersRefineModal button={
                    (handleClick) => (
                        <Link
                            handleClick={handleClick}
                            underline="none"
                            trackingLabel={'Button for refine filters'}
                        >
                            <FontAwesomeIcon icon={faSlidersH} className={classes.icon} />
                            <Typography display="inline" variant="subtitle2">
                                Filters
                            </Typography>
                        </Link>
                    )
                } />
                <Separator type="vertical" insideFlexbox className={classes.separator} />
                <ExcessFilterDrawer />
            </div>
            <SortDrawer />
        </ContainerWrapper>
    );
};

_PolicyFiltersXs.propTypes = {
    isShowFiltersUpdateButton: PropTypes.bool,
    padding: PropTypes.array
};

const mapStateToProps = (state) => {
    // vertical.quote.results.config.filters.showFiltersUpdateButton
    const resultsStagedStateKey = 'filters.showFiltersUpdateButton';
    const isShowFiltersUpdateButton = resultsConfigSelector(state).getIn(resultsStagedStateKey.split('.'));
    return {
        isShowFiltersUpdateButton
    };
};

const PolicyFiltersXs = connect(mapStateToProps)(_PolicyFiltersXs);
export { PolicyFiltersXs };
